import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';
import classnames from 'classnames';
/* Constants */
import {
  CARAMEL_ENTRY_POINT_DATA,
  CARAMEL_ENTRY_POINT_PRIVATE_DATA,
} from 'client/site-modules/shared/constants/financing/caramel';
import { USED_SUMMARY_CHECKOUT } from 'client/site-modules/shared/constants/financing/financing-constants';
/* Utils */
import { getDealStatusTrackingValue } from 'site-modules/shared/utils/financing/get-deal-status-tracking-value';
/* Components */
import { CaramelBenefits } from 'client/site-modules/shared/components/financing/caramel/components/caramel-benefits/caramel-benefits';
import { CaramelLogo } from 'site-modules/shared/components/financing/caramel/components/caramel-logo/caramel-logo';
import { CaramelCta } from 'site-modules/shared/components/financing/caramel/components/caramel-cta/caramel-cta';

import './caramel-entry-point.scss';

export const CaramelEntryPoint = ({
  isEmbedded = false,
  handleCaramelMakeOffer = noop,
  isPartner = false,
  dealer = null,
  isPrivateListing = false,
  hideCta = false,
}) => {
  const data = isPrivateListing ? CARAMEL_ENTRY_POINT_PRIVATE_DATA : CARAMEL_ENTRY_POINT_DATA;
  const dealStatus = dealer?.dealStatus;
  const dealStatusTrackingValue = getDealStatusTrackingValue({ dealStatus });
  const { benefits, cta, header } = data;

  return (
    <div
      className={classnames('caramel-container', { embedded: isEmbedded })}
      style={{
        marginTop: '1rem',
        padding: isEmbedded ? '1rem 0 0' : '1rem',
        position: 'relative',
        boxSizing: 'border-box',
        ...(isEmbedded && {
          borderTop: ' 1px solid #cbd4e1',
          padding: '1rem 1.5rem 1.5rem',
          marginBottom: '-1.5rem',
          marginLeft: '-1.5rem',
          marginRight: '-1.5rem',
          overflow: 'hidden',
          minHeight: '259px',
        }),
      }}
      data-tracking-parent={
        isPrivateListing
          ? `${USED_SUMMARY_CHECKOUT}-private-party${dealStatusTrackingValue}${dealStatus ? '-right-rail' : ''}`
          : `${USED_SUMMARY_CHECKOUT}-${isPartner ? 'partner' : 'basic'}${dealStatusTrackingValue}`
      }
    >
      <h2
        className="text-cool-gray-30"
        style={{
          fontSize: '1.25rem',
          lineHeight: '1.5rem',
          fontWeight: 'bold',
          marginBottom: '0',
        }}
      >
        {header}
      </h2>
      <CaramelLogo />

      <CaramelBenefits benefits={benefits} />

      {!hideCta && (
        <CaramelCta
          dealStatus={dealStatus}
          handleCaramelMakeOffer={handleCaramelMakeOffer}
          cta={cta}
          isPrivateListing={isPrivateListing}
        />
      )}
    </div>
  );
};
CaramelEntryPoint.propTypes = {
  isEmbedded: PropTypes.bool,
  handleCaramelMakeOffer: PropTypes.func,
  isPartner: PropTypes.bool,
  dealer: PropTypes.shape({ dealStatus: PropTypes.string }),
  hideCta: PropTypes.bool,
  isPrivateListing: PropTypes.bool,
};
